import React, { useState, useEffect, useRef  } from "react";
import { Container, Row, Col, Modal, Image } from "react-bootstrap";
import RightFooter from "../common/RightFooter";
import t from "../../Utils/Translation";
import Tooltip from '@mui/material/Tooltip';
import LykioButton from "../common/LykioButton";
import Card from 'react-bootstrap/Card';
import { useNavigate } from "react-router-dom";
import MultiActionAreaCard from "./MultiActionAreaCard";
import {Viewer, Worker} from "@react-pdf-viewer/core";
import {defaultLayoutPlugin} from "@react-pdf-viewer/default-layout";
import Button from "@mui/material/Button";
import {Box} from "@mui/material";
import {AUTHORIZED_URL_PREFIX, AxiosConfig} from '../../Utils/Constants'; 
import axios from "axios";
import {startActivitySession, stopActivitySession, useUpdateActivitySession} from "../../Utils/TimerUtils";
import Loading from './../common/Loading';

const Insights = () => {
    const [ isLoading, setIsLoading ] = useState(true);
    const [unitUsage, setUnitUsage] = useState([]);
    const isPiPSupported = document.pictureInPictureEnabled || false;
    const videoRef = useRef(null);
  
    useEffect(() => {
          const fetchUnitUsage = async () => {
              try {
                  const { data } = await axios.post(`${AUTHORIZED_URL_PREFIX}${"/user/getResultsByType"}`,{type: 'Insights'}, AxiosConfig());
                  setUnitUsage(data.unitUsage);
                  console.log(data.unitUsage);
                  setIsLoading(false);
                  if (!data.success) {
                      console.log('error')
                  }
              } catch (error) {
                  console.log(error);
              }
          };
          fetchUnitUsage();
          
      }, []);
    

    const transform = (slot) => ({
        ...slot,
        // These slots will be empty
        Open: () => <></>
    });

    const renderToolbar = (Toolbar) => (
        <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
    )
    const defaultLayoutPluginInstance = defaultLayoutPlugin({renderToolbar,});

    const {renderDefaultToolbar} = defaultLayoutPluginInstance.toolbarPluginInstance
    const [isRunning, setIsRunning] = useState(false);
    const [testId, setTestId] = useState('')

    useUpdateActivitySession(testId, isRunning)

  const [modal, setModal] = useState(null);
  const handleOpen = async(id) => {
      setModal(id);
      setTestId("a00"+id)
      const results = {
        id: "a00"+id,
        type: "Insights"
        }
        console.log(results);

      startActivitySession(results.id)
      setIsRunning(true)

        const {data} = await axios.post(
            `${AUTHORIZED_URL_PREFIX}${"/user/saveResults"}`,
            {results: results},
            AxiosConfig()
        )
  };

  const handleClose = () => {
      if (videoRef.current) {
        console.log(" videoRef.current:", videoRef.current)
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
      if (isPiPSupported) {
        document
      .exitPictureInPicture()
      .then(() => console.log("Document Exited from Picture-in-Picture mode"))
      .catch((err) => console.error(err));
      }
      setModal(null);
      setIsRunning(false)
      stopActivitySession(testId, false);
      window.location.reload();
  };
  
  useEffect(() => {
    return () => {
      console.log("CHANGE PAGE");
      console.log("modal:",modal)
      if (modal) {
        console.log("videoRef.current:",videoRef.current)
        if (videoRef.current) {
            videoRef.current.currentTime = 0;
        }
      }
      if (isPiPSupported && document.pictureInPictureElement) {
        //console.log("videoRef.current:",videoRef.current)
        console.log("Exiting Picture-in-Picture mode");
        document.exitPictureInPicture()
          .then(() => console.log("Document Exited from Picture-in-Picture mode"))
          .catch((err) => console.error(err));
      }
    };
  }, [modal]);

  return (
    <div className="lykioccs-main-content lykiocss-Approfondimenti">
       
       {isLoading ? <Loading/> : <>
       <Container className="lykiocss-margin-top-5em">
        <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
                <div style={{background: "linear-gradient(to bottom, #01ac95, #76decd)",textAlign:'center', color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'24em'}} className="lykiocss-center">
                    {t("Learn more about the impact of biases in human resourses evaluation")}
                </div>
        </Row>
       </Container>
       <Container>
        <Row>
        <Col className="lykiocss-margin-top-half-em">
                <div className="hand" onClick={()=>{handleOpen(1)}}>
                <MultiActionAreaCard 
                completed={false}
                title={t("WHAT IS A BIAS").toUpperCase()}
                linkPDF="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/5_domande-da-evit_60888102.pdf" 
                cover={unitUsage.filter((item) => item.unitId==='a001').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/APP1-CHE+COS'E+UN+BIAS.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/1_.jpg"}
                                     height={'24em'} width={'22em'}
                 t={t} text={t('Start')} backgroundColor="#01ac95" lightBackgroundColor="#76decd" duration={3} level={"basic"}/>
                </div>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
                <div className="hand" onClick={()=>{handleOpen(2)}}>
                <MultiActionAreaCard 
                completed={false}
                title={t("BIASES THAT AFFECT THE RECRUITMENT PROCESS").toUpperCase()}
                linkPDF="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/5_domande-da-evit_60888102.pdf" 
                cover={unitUsage.filter((item) => item.unitId==='a002').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/APP2-I+BIAS+NELLA+SELEZIONE.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/2_.jpg"}                    
                height={'24em'} width={'22em'}
                 t={t} text={t('Start')} backgroundColor="#01ac95" lightBackgroundColor="#76decd" duration={5} level={"basic"}/>
                </div>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
                <div className="hand" onClick={()=>{handleOpen(3)}}>
                <MultiActionAreaCard 
                completed={false}
                title={t("TIPS ON HOW TO REDUCE BIASES").toUpperCase()}
                linkPDF="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/5_domande-da-evit_60888102.pdf" 
                cover={unitUsage.filter((item) => item.unitId==='a003').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/APP3-COME+RIDURRE+L'IMPATTO+DEI+BIAS.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/3_.jpg"}                     
                height={'24em'} width={'22em'}
                 t={t} text={t('Start')} backgroundColor="#01ac95" lightBackgroundColor="#76decd" duration={6} level={"basic"}/>
                </div>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
                <div className="hand" onClick={()=>{handleOpen(4)}}>
                <MultiActionAreaCard 
                completed={false}
                title={t("QUESTIONS TO AVOID").toUpperCase()}
                linkPDF="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/5_domande-da-evit_60888102.pdf" 
                cover={unitUsage.filter((item) => item.unitId==='a004').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/APP4-DOMANDE+DA+EVITARE.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/4_.jpg"}                     
                height={'24em'} width={'22em'}
                 t={t} text={t('Start')} backgroundColor="#01ac95" lightBackgroundColor="#76decd" duration={2} level={"advanced"}/>
                </div>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
                <div className="hand" onClick={()=>{handleOpen(5)}}>
                <MultiActionAreaCard 
                completed={false}
                title={t("INCLUSIVE LANGUAGE").toUpperCase()}
                cover={unitUsage.filter((item) => item.unitId==='a005').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/APP5-LINGUAGGIO+INCLUSIVO.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/5_cover.jpg"}                     
                height={'24em'} width={'22em'}
                 t={t} text={t('Start')} backgroundColor="#01ac95" lightBackgroundColor="#76decd" duration={2} level={"advanced"}/>
                </div>
            </Col>
            
            <Col className="lykiocss-margin-top-half-em">
                <div className="hand" onClick={()=>{handleOpen(6)}}>
                <MultiActionAreaCard 
                completed={false}
                title={t("DISABILITY ETIQUETTE").toUpperCase()}
                linkPDF="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/6-galateo-della-disabilita.pdf" 
                cover={unitUsage.filter((item) => item.unitId==='a006').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/APP6-GALATEO+DELLA+DISABILITA.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/6_cover.jpg"}                     
                height={'24em'} width={'22em'}
                 t={t} text={t('Start')} backgroundColor="#01ac95" lightBackgroundColor="#76decd" duration={2} level={"advanced"}/>
                </div>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
                <div className="hand" onClick={()=>{handleOpen(7)}}>
                <MultiActionAreaCard 
                completed={false}
                title={t("INCLUSIVE INTERVIEW AT MICROSOFT").toUpperCase()}
                cover={unitUsage.filter((item) => item.unitId==='a007').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/APP7-COLLOQUIO+INCLUSIVO+IN+MICROSOFT.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/7_cover.jpg"}                     
                height={'24em'} width={'22em'}
                 t={t} text={t('Start')} backgroundColor="#01ac95" lightBackgroundColor="#76decd" duration={2} level={"advanced"}/>
                </div>
            </Col>
           
            <Col className="lykiocss-margin-top-half-em">
                <div className="hand" onClick={()=>{handleOpen(8)}}>
                <MultiActionAreaCard 
                completed={false}
                title={t("5 reasons why diversity hiring matters").toUpperCase()}
                cover={unitUsage.filter((item) => item.unitId==='a008').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/APP8-VANTAGGI+DEL+RECLUTAMENTO+INCLUSIVO.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/apro8.jpg"}                     
                height={'24em'} width={'22em'}
                 t={t} text={t('Start')} backgroundColor="#01ac95" lightBackgroundColor="#76decd" duration={2} level={"basic"}/>
                </div>
            </Col>

            <Col className="lykiocss-margin-top-half-em">
                <div className="hand" onClick={()=>{handleOpen(9)}}>
                <MultiActionAreaCard 
                completed={false}
                title={t("Inclusive language and gender").toUpperCase()}
                cover={unitUsage.filter((item) => item.unitId==='a009').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/APP9-LINGUAGGIO+INCLUSIVO+E+GENERE.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/apro9.jpg"}                    
                height={'24em'} width={'22em'}
                 t={t} text={t('Start')} backgroundColor="#01ac95" lightBackgroundColor="#76decd" duration={3} level={"advanced"}/>
                </div>
            </Col>


            {/* <Col className="lykiocss-margin-top-half-em">
                <MultiActionAreaCard height={'24em'} width={'22em'} t={t} text={t('Start')} backgroundColor="#01ac95" lightBackgroundColor="#76decd" duration={'?'} cover="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/locks/green_lock1.png" comingSoon={true}/>
            </Col>
            <Col className="lykiocss-margin-top-half-em">
                <MultiActionAreaCard height={'24em'} width={'22em'} t={t} text={t('Start')} backgroundColor="#01ac95" lightBackgroundColor="#76decd" duration={'?'} cover="https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/locks/green_lock1.png" comingSoon={true}/>
            </Col> */}
        </Row>
       </Container>
       </>}
      <RightFooter />



        {modal === 1 && (
        <Modal show={true} onHide={handleClose} fullscreen={true} >
            <Modal.Header closeButton>
                <Modal.Title>{t("WHAT IS A BIAS").toUpperCase()}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Box height={'80vh'} position={'relative'}>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                        <div   style={{
                            height: '100%',
                            width: '100%'
                        }}>
                            <Viewer fitToWidth={true} fileUrl={localStorage.getItem("i18n")==="it" ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/1_-cos-e-un-bias.pdf" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/1_-what-is-a-bias.pdf"} plugins={[defaultLayoutPluginInstance]} />
                        </div>
                    </Worker>
                </Box>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t("Close")}
                </Button>
            </Modal.Footer>
        </Modal>
        )}

        {modal === 2 && (
        <Modal show={true} onHide={handleClose} fullscreen={true} >
            <Modal.Header closeButton>
                <Modal.Title>{t("BIASES THAT AFFECT THE RECRUITMENT PROCESS").toUpperCase()}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Box height={'80vh'} position={'relative'}>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                        <div   style={{
                            height: '100%',
                            width: '100%'
                        }}>
                            <Viewer fitToWidth={true} fileUrl={localStorage.getItem("i18n")==="it" ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/2_-i-bias-che-influenzano-la-selezione.pdf" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/2_-Biases+that+affect+the+recruitment+process.pdf"} plugins={[defaultLayoutPluginInstance]} />
                        </div>
                    </Worker>
                </Box>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t("Close")}
                </Button>
            </Modal.Footer>
        </Modal>
        )}

        {modal === 3 && (
        <Modal show={true} onHide={handleClose} fullscreen={true} >
            <Modal.Header closeButton>
                <Modal.Title>{t("TIPS ON HOW TO REDUCE BIASES").toUpperCase()}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Box height={'80vh'} position={'relative'}>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                        <div   style={{
                            height: '100%',
                            width: '100%'
                        }}>
                            <Viewer fitToWidth={true} fileUrl={localStorage.getItem("i18n")==="it" ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/3_-suggerimenti-per-ridurre-l'impatto-dei-bias.pdf" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/3_-Tips+on+how+to+reduce+biases'+impact.pdf"} plugins={[defaultLayoutPluginInstance]} />
                        </div>
                    </Worker>
                </Box>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t("Close")}
                </Button>
            </Modal.Footer>
        </Modal>
        )}

        {modal === 4 && (
        <Modal show={true} onHide={handleClose} fullscreen={true} >
            <Modal.Header closeButton>
                <Modal.Title>{t("QUESTIONS TO AVOID").toUpperCase()}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Box height={'80vh'} position={'relative'}>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                        <div   style={{
                            height: '100%',
                            width: '100%'
                        }}>
                            <Viewer fitToWidth={true} fileUrl={localStorage.getItem("i18n")==="it" ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/4_domande-da-evit_60888102.pdf" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/4_-questions+to+avoid.pdf"} plugins={[defaultLayoutPluginInstance]} />
                        </div>
                    </Worker>
                </Box>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t("Close")}
                </Button>
            </Modal.Footer>
        </Modal>
        )}

        {modal === 5 && (
        <Modal show={true} onHide={handleClose} fullscreen={true} >
            <Modal.Header closeButton>
                <Modal.Title>{t("INCLUSIVE LANGUAGE").toUpperCase()}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Box height={'80vh'} position={'relative'}>
                    <video ref={videoRef} style={{ width: '100%', height: '100%' }} src={localStorage.getItem("i18n")==="it" ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/5-linguaggio-inclusivo.mp4" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/5-ENG-Inclusive+language.mp4"} controls />
                </Box>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t("Close")}
                </Button>
            </Modal.Footer>
        </Modal>
        )}                    


        {modal === 6 && (
            <Modal show={true} onHide={handleClose} fullscreen={true} >
                <Modal.Header closeButton>
                    <Modal.Title>{t("DISABILITY ETIQUETTE").toUpperCase()}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Box height={'80vh'} position={'relative'}>
                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                            <div   style={{
                                height: '100%',
                                width: '100%'
                            }}>
                                <Viewer fitToWidth={true} fileUrl={localStorage.getItem("i18n")==="it" ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/6-galateo-della-disabilita.pdf" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/6-ENG-Disability+etiquette.pdf"} plugins={[defaultLayoutPluginInstance]} />
                            </div>
                        </Worker>
                    </Box>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {t("Close")}
                    </Button>
                </Modal.Footer>
            </Modal>
            )}

        {modal === 7 && (
        <Modal show={true} onHide={handleClose} fullscreen={true} >
            <Modal.Header closeButton>
                <Modal.Title>{t("INCLUSIVE INTERVIEW AT MICROSOFT").toUpperCase()}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Box height={'80vh'} position={'relative'}>
                    <video ref={videoRef} style={{ width: '100%', height: '100%' }} src={localStorage.getItem("i18n")==="it" ? 'https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/7-colloquio-inclusivo-in-microsoft.mp4' : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/aprofondimenti/7-ENG-Inclusive+Hiring+at+Microsoft.mp4"} controls />
                </Box>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t("Close")}
                </Button>
            </Modal.Footer>
        </Modal>
        )}  


        {modal === 8 && (
        <Modal show={true} onHide={handleClose} fullscreen={true} >
            <Modal.Header closeButton>
                <Modal.Title>{t("5 reasons why diversity hiring matters").toUpperCase()}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <Box height={'80vh'} position={'relative'}>
                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                            <div   style={{
                                height: '100%',
                                width: '100%'
                            }}>
                                <Viewer fitToWidth={true} fileUrl={localStorage.getItem("i18n")==="it" ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/5+vantaggi+del+reclutamento+inclusivo+(ITA).pdf" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/5+reasons+why+diversity+hiring+matters+(ENG).pdf"} plugins={[defaultLayoutPluginInstance]} />
                            </div>
                        </Worker>
                    </Box>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t("Close")}
                </Button>
            </Modal.Footer>
        </Modal>
        )}  

        {modal === 9 && (
        <Modal show={true} onHide={handleClose} fullscreen={true} >
            <Modal.Header closeButton>
                <Modal.Title>{t("Inclusive language and gender").toUpperCase()}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
    <Image 
        src={localStorage.getItem("i18n")==="it" ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Linguaggio+inclusivo+e+genere+(ITA).png" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Inclusive+Language+and+Gender+(ENG).png"} 
        alt="Inclusive Language and Gender"
        fluid
    />
</Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t("Close")}
                </Button>
            </Modal.Footer>
        </Modal>
        )}  

    </div>
  )
};

export default Insights;